/* Victorieboontje redesign — btw-toggle, lease/koop, keuzehulp, eventaanvraag. Specificatie: projectdoc 09. */
(function () {
  if (window.__vbInit) return; window.__vbInit = true;
  var KEY = 'vb-vat';
  function getVat() { try { return sessionStorage.getItem(KEY) || 'ex'; } catch (e) { return 'ex'; } }
  function setVat(v) {
    document.documentElement.setAttribute('data-vb-vat', v);
    try { sessionStorage.setItem(KEY, v); } catch (e) {}
    document.querySelectorAll('[data-vb-vat-set]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.vbVatSet === v)); });
  }

  function initBuybox(root) {
    root.querySelectorAll('[data-vb-tabs]').forEach(function (box) {
      var tabs = box.querySelectorAll('[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) { o.setAttribute('aria-selected', String(o === t)); });
          box.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
          box.querySelectorAll('[data-show-on]').forEach(function (p) { p.hidden = p.dataset.showOn !== t.dataset.tab; });
        });
      });
    });
    root.querySelectorAll('[data-vb-variant]').forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('variant', s.value); location.href = u.toString(); });
    });
  }

  /* ---------- Keuzehulp ---------- */
  var RANGES = { '1-5': [1, 5], '6-20': [6, 20], '21-50': [21, 50], '51+': [51, 100000] };
  function hasDrink(p, d) { return Array.isArray(p.dranken) && p.dranken.some(function (x) { return String(x).toLowerCase().indexOf(d) > -1; }); }
  function hasCat(p, c) { return Array.isArray(p.cats) && p.cats.indexOf(c) > -1; }
  function filter(p, a, factor) {
    var r = RANGES[a.personen];
    if (p.team_min == null || p.team_max == null) return false;
    if (p.team_max < r[0] || p.team_min > r[1]) return false;
    var wil = function (d) { return a.dranken.indexOf(d) > -1; };
    if ((wil('melk') || wil('chocolade')) && Array.isArray(p.cats)) {
      if (!hasCat(p, 'melk')) return false;
      if (p.melk === 'stoompijp' && p.bediening === 'self-service') return false;
    } else if (wil('melk') || wil('chocolade')) {
      if (!p.melk) return false;
      var okMelk = ['verse_melk', 'melkpoeder', 'losse_opschuimer'].indexOf(p.melk) > -1 || (p.melk === 'stoompijp' && p.bediening && p.bediening !== 'self-service');
      if (!okMelk) return false;
    }
    if (wil('chocolade') && !(Array.isArray(p.cats) ? hasCat(p, 'chocolade') : hasDrink(p, 'choc'))) return false;
    if (a.water === 'reservoir' && ['reservoir', 'beide'].indexOf(p.water) < 0) return false;
    if (a.water === 'vast' && ['vast', 'beide'].indexOf(p.water) < 0) return false;
    if (a.gebruik === 'horeca') { if (!p.horeca) return false; } else if (!p.zakelijk) return false;
    if (factor > 0) { if (p.dag_max == null) return false; if (p.dag_max < Math.min(r[1], 100) * factor) return false; }
    return true;
  }
  function score(p, a, set) {
    var s = Number(p.prio) || 0;
    if (a.prio === 'smaak' && (p.melk === 'verse_melk' || p.type === 'piston')) s += 15;
    if (a.prio === 'onderhoud' && ['vast', 'beide'].indexOf(p.water) > -1 && p.bediening === 'self-service') s += 15;
    if (a.prio === 'snelheid') { var max = Math.max.apply(null, set.map(function (x) { return x.uur_max || 0; })); if (max > 0) s += 15 * (p.uur_max || 0) / max; }
    if (a.prio === 'uitstraling' && p.featured === 'featured') s += 15;
    var wil = function (d) { return a.dranken.indexOf(d) > -1; };
    if (wil('uitgebreid')) s += 3 * ((p.cats || []).length);
    if (wil('melk') && p.melk === 'verse_melk') s += 5;
    if (p.rep) s += 1;
    if (a.prio === 'kosten') { var min = Math.min.apply(null, set.map(function (x) { return x.basis || Infinity; })); if (p.basis && isFinite(min)) s += 25 * min / p.basis; }
    if (a.dranken.length === 1 && wil('zwart') && p.melk && p.melk !== 'geen') s -= 5;
    if (a.gebruik === 'bezoek' && p.featured === 'featured') s += 10;
    return s;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function initKeuzehulp(root) {
    var form = root.querySelector('[data-kh-form]'); if (!form) return;
    var data = []; try { data = JSON.parse(root.querySelector('[data-kh-data]').textContent); } catch (e) {}
    var factor = Number(root.dataset.factor) || 0;
    var out = root.querySelector('[data-kh-result]');
    var vbx = {}; try { vbx = JSON.parse((root.querySelector('[data-kh-vbx]') || {}).textContent || '{}'); } catch (e) {}
    function vbxCard(type) {
      var t = type === 'compact' ? { n: 'Victoriebox Compact', p: vbx.compact, d: 'Machine in bruikleen, koffie en support voor 1–5 koffiedrinkers. Na 12 weken per 4 weken opzegbaar.' }
                                 : { n: 'Victoriebox Plus', p: vbx.plus, d: 'Voor 5–10 koffiedrinkers: machine in bruikleen, koffie en support. Na 12 weken per 4 weken opzegbaar.' };
      return '<article class="vb-kh__card vb-kh__card--vbx"><p class="vb-badge">' + (type === 'compact' ? 'Ons advies voor kleine teams' : 'Tot 10 koffiedrinkers') + '</p><h3 class="vb-h4"><a href="' + esc(vbx.url || '/pages/victoriebox') + '">' + esc(t.n) + '</a></h3><p>' + esc(t.p || '') + '</p><p class="vb-small">' + esc(t.d) + '</p></article>';
    }
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var fd = new FormData(form), a = Object.fromEntries(fd.entries());
      a.dranken = fd.getAll('dranken');
      if (!a.dranken.length) a.dranken = ['zwart'];
      var set = data.filter(function (p) { return filter(p, a, factor); });
      set.forEach(function (p) { p._s = score(p, a, set); });
      set.sort(function (x, y) { return (y._s - x._s) || ((x.basis || 9e12) - (y.basis || 9e12)); });
      // Eén machine per familie/serie: de best scorende uitvoering (besluit 26-10)
      var seen = {}; set = set.filter(function (p) { var f = p.fam || p.title; if (seen[f]) return false; seen[f] = true; return true; });
      // Variatie (besluit 26-10): hoofdadvies + bij voorkeur een ander merk + een voordeliger optie
      var top = [];
      if (set.length) {
        var h0 = set[0]; top.push(h0);
        var used = {}; used[h0.vendor] = true;
        var cheap = set.filter(function (p) { return p !== h0 && p.basis && h0.basis && p.basis < h0.basis; });
        var other = set.filter(function (p) { return p !== h0 && !used[p.vendor]; });
        var a1 = other[0] || set[1];
        if (a1) { top.push(a1); used[a1.vendor] = true; }
        var a2 = cheap.filter(function (p) { return top.indexOf(p) < 0 && !used[p.vendor]; })[0] || cheap.filter(function (p) { return top.indexOf(p) < 0; })[0] || set.filter(function (p) { return top.indexOf(p) < 0 && !used[p.vendor]; })[0] || set.filter(function (p) { return top.indexOf(p) < 0; })[0];
        if (a2) top.push(a2);
      }
      // Kleine teams: eerst de Victoriebox (besluit 26-10). Niet bij horeca of chocolade (geen instant in de box).
      var vbxType = null;
      if (a.gebruik !== 'horeca' && a.dranken.indexOf('chocolade') < 0 && a.dranken.indexOf('uitgebreid') < 0) {
        if (a.personen === '1-5') vbxType = 'compact'; else if (a.personen === '6-20') vbxType = 'plus';
      }
      if (!top.length && vbxType) {
        out.innerHTML = '<h2 class="vb-h3">Dit zou Rowan bij jullie neerzetten</h2>' + vbxCard(vbxType);
      } else if (!top.length) {
        out.innerHTML = '<h2 class="vb-h3">Geen passende machine gevonden</h2><p>We denken graag mee. Bel of app Rowan, of laat je gegevens achter.</p>';
      } else {
        var h = top[0];
        var html = '<h2 class="vb-h3">Dit zou Rowan bij jullie neerzetten</h2>' + (vbxType ? vbxCard(vbxType) : '') + card(h, vbxType ? (vbxType === 'plus' ? 'Meer dan 10 koffiedrinkers' : 'Liever een eigen machine') : 'Hoofdadvies');
        if (top.length > 1) html += '<p class="vb-strong">Of kijk naar</p>' + top.slice(1).map(function (p) {
          var lbl = (p.basis && h.basis && p.basis < h.basis) ? 'Voordeliger' : ((p.dag_max || 0) > (h.dag_max || 0) ? 'Meer capaciteit' : 'Ook geschikt');
          return card(p, lbl);
        }).join('');
        if (a.water === 'onbekend') html += '<p class="vb-small">We checken samen je wateraansluiting.</p>';
        out.innerHTML = html;
      }
      out.hidden = false; out.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    function card(p, label) {
      return '<article class="vb-kh__card">' + (p.img ? '<div class="vb-kh__card-media"><img src="' + esc(p.img) + '" alt="" width="200" height="200" loading="lazy"></div>' : '') +
        '<div class="vb-kh__card-body"><p class="vb-badge">' + esc(label) + '</p><h3 class="vb-h4"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' + (p.lease_html || '') +
        '<a class="vb-kh__more" href="' + esc(p.url) + '">Bekijk de ' + esc(p.title) + '</a></div></article>';
    }
  }

  /* ---------- Eventaanvraag ---------- */
  function initEvent(root) {
    var form = root.querySelector('form'); if (!form) return;
    var s1 = root.querySelector('[data-step="1"]'), s2 = root.querySelector('[data-step="2"]'), s3 = root.querySelector('[data-step="3"]');
    if (!s1 || !s2 || !s3) return;
    var dB = Number(root.dataset.drempelBakkiebar) || 0, dM = Number(root.dataset.drempelMaatwerk) || 0;
    function val(n) { var el = form.querySelector('[data-ev="' + n + '"]' + (n === 'locatie' ? ':checked' : '')); return el ? el.value : ''; }
    root.querySelector('[data-ev-next]').addEventListener('click', function () {
      var req = s1.querySelectorAll('[required]'), ok = true;
      req.forEach(function (el) { if (!el.checkValidity()) { ok = false; } });
      if (!ok) { form.reportValidity(); return; }
      var gasten = Number(val('gasten')), loc = val('locatie');
      var bar = 'Koffietrailer';
      if (loc === 'Binnen' && dB > 0 && gasten <= dB) bar = 'BakkieBar';
      var maat = dM > 0 && gasten >= dM;
      root.querySelector('[data-ev-bar]').textContent = val('soort') + ' · ' + gasten + ' gasten · ' + loc.toLowerCase() + ' — voorstel: ' + bar + ' met barista';
      root.querySelector('[data-ev-bar-input]').value = maat ? 'Maatwerk' : bar;
      root.querySelector('[data-ev-msg]').textContent = maat ? 'Voor dit event maken we graag een voorstel op maat.' : 'We stemmen de bar en bezetting af op je gasten, programma en locatie. Je ontvangt vooraf een compleet voorstel.';
      s2.hidden = false; s2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    /* Pakket ↔ extra uren: verlengen kan tot de duur van het volgende pakket; daarboven het grotere pakket voorstellen.
       Bij het pakket met alles inbegrepen worden patisserie en uitgebreid assortiment automatisch aangevinkt. */
    var pkgs = [].slice.call(form.querySelectorAll('[data-ev-pakket]')), uren = [].slice.call(form.querySelectorAll('[data-ev-uren]'));
    var info = form.querySelector('[data-ev-uren-info]'), upsell = form.querySelector('[data-ev-upsell]'), meer = form.querySelector('[data-ev-meer]');
    var uurPrijs = info ? Number(info.dataset.uurPrijs) || 0 : 0, uurCons = info ? Number(info.dataset.uurCons) || 0 : 0;
    var incl = [].slice.call(form.querySelectorAll('[data-ev-incl]'));
    function num(el, k) { return Number(el.dataset[k]) || 0; }
    function eur(n) { return '€ ' + n.toLocaleString('nl-NL'); }
    function syncPakket() {
      var p = form.querySelector('[data-ev-pakket]:checked'); if (!p) return;
      var i = pkgs.indexOf(p), next = pkgs[i + 1], alles = p.hasAttribute('data-alles-incl');
      incl.forEach(function (c) {
        var lab = c.parentNode.querySelector('[data-ev-incl-label]');
        if (alles) { c.checked = true; c.dataset.locked = '1'; c.setAttribute('aria-readonly', 'true'); }
        else if (c.dataset.locked) { c.checked = false; delete c.dataset.locked; c.removeAttribute('aria-readonly'); }
        if (lab) lab.hidden = !alles;
      });
      if (alles) { var w = form.querySelector('[data-ev-wensen]'); if (w) w.open = true; }
      var maxN = next ? num(next, 'uur') - num(p, 'uur') : Infinity;
      uren.forEach(function (r) {
        var n = Number(r.dataset.evUren);
        var off = !isNaN(n) && n > maxN;
        r.disabled = off; r.parentNode.classList.toggle('is-disabled', off);
        if (off && r.checked) uren[0].checked = true;
      });
      var u = form.querySelector('[data-ev-uren]:checked'), n = u ? Number(u.dataset.evUren) : 0;
      if (meer) meer.hidden = !(u && u.dataset.evUren === 'overleg');
      var tip = '';
      if (next && maxN !== Infinity && uren.some(function (r) { return r.disabled; })) {
        tip = 'Langer dan ' + (num(p, 'uur') + maxN) + ' uur? Kies ' + next.dataset.naam + ' (' + num(next, 'uur') + ' uur, tot ' + num(next, 'cons') + ' consumpties' + (next.hasAttribute('data-alles-incl') ? ', met patisserie en uitgebreid assortiment' : '') + ', ' + eur(num(next, 'prijs')) + ' excl. btw) en verleng dat pakket.';
        if (n > 0 && uurPrijs > 0) {
          var totaal = num(p, 'prijs') + n * uurPrijs, cons = num(p, 'cons') + n * uurCons;
          tip = p.dataset.naam + ' + ' + n + ' uur: ' + eur(totaal) + ' excl. btw, tot ' + cons + ' consumpties. ' + tip;
        }
      }
      if (upsell) { upsell.textContent = tip; upsell.hidden = !tip; }
    }
    incl.forEach(function (c) { c.addEventListener('click', function (e) { if (c.dataset.locked) e.preventDefault(); }); });
    pkgs.concat(uren).forEach(function (r) { r.addEventListener('change', syncPakket); });
    syncPakket();
    root.querySelector('[data-ev-next2]').addEventListener('click', function () {
      var p = form.querySelector('[data-ev-pakket]:checked'), u = form.querySelector('[data-ev-uren]:checked');
      var d = val('datum').split('-').reverse().join('-'), extra = '';
      if (u && u.dataset.evUren === 'overleg') {
        var tu = form.querySelector('[name="contact[Totaal aantal uren]"]').value, td = form.querySelector('[name="contact[Aantal dagen]"]').value;
        extra = 'meer uren in overleg' + (tu ? ', totaal ' + tu + ' uur' : '') + (td ? ', ' + td + ' dagen' : '');
      } else if (u && u.value !== 'Geen extra uren') extra = 'extra uren: ' + u.value;
      root.querySelector('[data-ev-summary]').textContent = [val('soort'), d, val('gasten') + ' gasten', val('locatie'), root.querySelector('[data-ev-bar-input]').value, p ? p.value : '', extra].filter(Boolean).join(' · ');
      s3.hidden = false; s3.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    setVat(getVat());
    document.addEventListener('click', function (e) { var b = e.target.closest('[data-vb-vat-set]'); if (b) setVat(b.dataset.vbVatSet); });
    document.querySelectorAll('[data-vb-root]').forEach(initBuybox);
    document.querySelectorAll('[data-vb-keuzehulp]').forEach(initKeuzehulp);
    document.querySelectorAll('[data-vb-event]').forEach(initEvent);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
